export enum IP_PIN_TYPES {
  SELF = 'SELF',
  SPOUSE = 'SPOUSE',
}
